/*----------------------
   CART
---------------------- */
Cart = {
    init: function () {

        function verificarProductoEnCarrito(handle) {
            $.getJSON('/cart.js', function (cart) {
                var productoEncontrado = cart.items.some(function (item) {
                    return item.handle === handle;
                });

                if (productoEncontrado) {
                    $(".cart__items__related__product-gift").removeClass("open");
                } else {
                    $(".cart__items__related__product-gift").addClass("open");
                }
            });
        }
        verificarProductoEnCarrito('es-un-regalo');


        $("#gift-check").on("change", function (e) {
            if ($("#gift-check").prop("checked")) {
                if ($("#gift-text").val().trim() !== '') {
                    let json = { 'items': [{ 'id': Number($("#gift-check").data("gift-product")), 'quantity': 1, 'properties': { [$("#gift-check").data("gift-property")]: $("#gift-text").val() } }] };
                    $.post(window.Shopify.routes.root + 'cart/add.js', json, null, "json")
                        .done(function (data) {

                            location.href = "/cart";
                        })
                        .fail(function (data) {
                            $("#gift-check").prop("checked", false);
                        })
                        .always(function (data) {
                        });
                } else {
                    $("#gift-check").prop("checked", false);
                    $("#gift-text").css("border-bottom", "1px solid red");
                }
            }
        });

        $("#gift-text").on("focus", function () {
            $(this).css("border-bottom", "1px solid black");
        });
    }
}



CartRelated = {
    init: function () {

        $(".button-add-related").on("click", function () {
            let json = { 'items': [{ 'id': Number($(this).data("id")), 'quantity': 1, 'properties': { [$("#gift-check").data("gift-property")]: $("#gift-text").val() } }] };
            $.post(window.Shopify.routes.root + 'cart/add.js', json, null, "json")
                .done(function (data) {
                    location.href = "/cart";
                })
                .fail(function (data) {
                    console.log("error");
                })
                .always(function (data) {
                });
        });
    }
}

Cart.init();
CartRelated.init();